import { render, staticRenderFns } from "./PositionModal.vue?vue&type=template&id=15ac9682&scoped=true&"
import script from "./PositionModal.vue?vue&type=script&lang=js&"
export * from "./PositionModal.vue?vue&type=script&lang=js&"
import style0 from "./PositionModal.vue?vue&type=style&index=0&id=15ac9682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac9682",
  null
  
)

export default component.exports